/*
 * Nimbus — Sugar Beauty Academy hero enhancer
 * Runs on the ldt course app page (/a/my-courses). The theme layout loads on
 * app-proxy pages, so this runs there; it no-ops everywhere else.
 *
 * Two jobs:
 *  1. Fill the hero stats + "Continue learning" link (the app strips <script>
 *     from custom HTML, so this must live in the theme).
 *  2. Build the banner top bar: CLONE the app's greeting + logout + bell into
 *     the hero's .sbah__top. We clone (never move) React-managed nodes — moving
 *     them crashes the app ("removeChild ... not a child"). The originals are
 *     hidden with CSS. A MutationObserver rebuilds the clones if the app
 *     re-renders and wipes them.
 */
(function () {
  function progress(item) {
    var m = (item.textContent || '').match(/(\d+)%/);
    return m ? parseInt(m[1], 10) : 0;
  }
  // Zoek de cursuslink op het URL-patroon, niet op de knoptekst: "View" wordt
  // vertaald ("Bekijken", "Ver", ...) en dan vond de oude check niets meer.
  function viewHref(item) {
    var links = [].slice.call(item.querySelectorAll('a[href]'));
    var link = links.filter(function (a) {
      return /\/a\/my-courses\/course\//.test(a.getAttribute('href') || '');
    })[0] || links[0];
    return link ? link.getAttribute('href') : null;
  }

  // Onthoud de laatst geopende les, zodat "Continue learning" echt verdergaat
  // waar de cursist gebleven was (de app biedt dit zelf niet aan).
  var LAST_KEY = 'sbah:last-lesson';
  function rememberLesson() {
    try {
      var m = location.pathname.match(/\/a\/my-courses\/course\/[^/]+(?:\/[^/]+)?/);
      if (m) localStorage.setItem(LAST_KEY, m[0] + location.search);
    } catch (e) { /* private mode */ }
  }
  function lastLesson() {
    try { return localStorage.getItem(LAST_KEY); } catch (e) { return null; }
  }

  // The app pins its notification popover top-left (anchored to the hidden
  // original bell). base.css moves it to the top-right corner under the header
  // with !important; here we just feed it the live header height so it sits
  // snug under the header on any viewport.
  function positionNotif() {
    var hdr = document.querySelector('.nimbus-header');
    var topPx = hdr ? Math.round(hdr.getBoundingClientRect().bottom) + 8 : 117;
    document.documentElement.style.setProperty('--sbah-notif-top', topPx + 'px');
  }

  // The ldt app's rich-text editor can re-save the custom HTML and inject <br>
  // elements between every block plus literal "&nbsp;" text nodes. That blows the
  // hero layout apart, so strip them on load (and after every re-render).
  function sanitizeHero() {
    var scopes = document.querySelectorAll('#ldt-app-proxy-root .sbah-wrap, #ldt-app-proxy-root .sbah');
    if (!scopes.length) return;
    [].forEach.call(scopes, function (scope) {
      [].forEach.call(scope.querySelectorAll('br'), function (br) { br.remove(); });
      var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
      var junk = [], n;
      while ((n = walker.nextNode())) {
        if (/&nbsp;/.test(n.nodeValue || '')) junk.push(n);
      }
      junk.forEach(function (node) {
        var cleaned = (node.nodeValue || '').replace(/&nbsp;/g, '').replace(/\u00a0/g, ' ');
        if (!cleaned.trim() && node.parentNode) { node.parentNode.removeChild(node); }
        else { node.nodeValue = cleaned; }
      });
    });
  }

  function buildTopBar() {
    var sbah = document.querySelector('#ldt-app-proxy-root .sbah');
    if (!sbah) return false;

    var topBar = sbah.querySelector('.sbah__top');
    if (!topBar) {
      topBar = document.createElement('div');
      topBar.className = 'sbah__top';
      var glow = sbah.querySelector('.sbah__glow');
      sbah.insertBefore(topBar, glow ? glow.nextSibling : sbah.firstChild);
    }
    if (topBar.querySelector('.sbah__member') || topBar.querySelector('.sbah__bell')) {
      return true; // already built
    }

    var member = document.querySelector('#ldt-app-proxy-root .ldt-cr-member');
    if (!member) return false; // wait for it to render

    var memberClone = member.cloneNode(true);
    memberClone.classList.add('sbah__member');
    [].slice.call(memberClone.querySelectorAll('.ldt-cr-lastName')).forEach(function (e) {
      e.parentNode.removeChild(e); // drop the last name
    });
    topBar.appendChild(memberClone);

    var nav = document.querySelector('#ldt-app-proxy-root .ldt-cr-course-top-nav');
    var bell = nav ? nav.querySelector('button') : null;
    if (bell) {
      var bellClone = bell.cloneNode(true);
      bellClone.classList.add('sbah__bell');
      bellClone.addEventListener('click', function () {
        // Re-query — the app remounts its nodes, so a cached ref goes stale.
        var n = document.querySelector('#ldt-app-proxy-root .ldt-cr-course-top-nav');
        var b = n ? n.querySelector('button') : null;
        if (b) b.click();
        positionNotif();
      });
      topBar.appendChild(bellClone);
    }

    // Keep the clones alive if the app re-renders the hero block.
    if (!sbah.dataset.sbahObserved) {
      sbah.dataset.sbahObserved = '1';
      new MutationObserver(function () { buildTopBar(); }).observe(sbah, {
        childList: true,
        subtree: true
      });
    }
    return true;
  }

  // Course / lesson page: turn the loose greeting + back link + bell into one
  // dark banner bar (same style as the my-courses hero). Clones only.
  function buildCourseBar() {
    var page = document.querySelector('#ldt-app-proxy-root .ldt-cr-course-page');
    if (!page) return false;
    if (page.querySelector('.sbah-bar')) return true; // already built

    var member = page.querySelector('.ldt-cr-member');
    var topnav = page.querySelector('.ldt-cr-course-top-nav');
    if (!member || !topnav) return false; // wait for render

    var back = topnav.querySelector('.ldt-cr-course-nav-back') || topnav.querySelector('a');
    var btns = [].slice.call(topnav.querySelectorAll('button'));
    var lessons = btns.filter(function (b) { return /Lessons/i.test(b.textContent); })[0];
    var bell = btns.filter(function (b) { return b.querySelector('svg') && !b.textContent.trim(); })[0];
    var greetingEl = member.querySelector('.ldt-cr-member-greeting') || member.querySelector('.ldt-cr-member-info');
    var logoutEl = member.querySelector('.ldt-cr-member-logout');

    var bar = document.createElement('div');
    bar.className = 'sbah-bar';

    // Left: back link
    var backWrap = document.createElement('div');
    backWrap.className = 'sbah-bar__back';
    if (back) backWrap.appendChild(back.cloneNode(true));
    bar.appendChild(backWrap);

    // Center: greeting (last name stripped)
    var gWrap = document.createElement('div');
    gWrap.className = 'sbah-bar__greeting';
    if (greetingEl) {
      var gClone = greetingEl.cloneNode(true);
      gClone.classList.add('sbah__member');
      [].slice.call(gClone.querySelectorAll('.ldt-cr-lastName')).forEach(function (e) {
        e.parentNode.removeChild(e);
      });
      gWrap.appendChild(gClone);
    }
    bar.appendChild(gWrap);

    // Right: logout + lessons (mobile) + bell
    var aWrap = document.createElement('div');
    aWrap.className = 'sbah-bar__actions';
    if (logoutEl) {
      var loClone = logoutEl.cloneNode(true);
      loClone.classList.add('sbah__member');
      aWrap.appendChild(loClone);
    }
    if (lessons) {
      var lClone = lessons.cloneNode(true);
      lClone.classList.add('sbah-lessons');
      lClone.addEventListener('click', function () {
        var n = document.querySelector('#ldt-app-proxy-root .ldt-cr-course-top-nav');
        var l = n && [].slice.call(n.querySelectorAll('button')).filter(function (x) { return /Lessons/i.test(x.textContent); })[0];
        if (l) l.click();
      });
      aWrap.appendChild(lClone);
    }
    if (bell) {
      var bClone = bell.cloneNode(true);
      bClone.classList.add('sbah__bell');
      bClone.addEventListener('click', function () {
        var n = document.querySelector('#ldt-app-proxy-root .ldt-cr-course-top-nav');
        var b = n && [].slice.call(n.querySelectorAll('button')).filter(function (x) { return x.querySelector('svg') && !x.textContent.trim(); })[0];
        if (b) b.click();
        positionNotif();
      });
      aWrap.appendChild(bClone);
    }
    bar.appendChild(aWrap);
    page.insertBefore(bar, page.firstChild);

    if (!page.dataset.barObserved) {
      page.dataset.barObserved = '1';
      new MutationObserver(function () {
        if (!page.querySelector('.sbah-bar')) buildCourseBar();
      }).observe(page, { childList: true });
    }

    buildBottomBar(bar);
    return true;
  }

  // Mobile: a sticky bottom bar that slides up once you scroll past the top bar.
  // Lives on <body> so position:fixed is relative to the viewport (an app
  // ancestor has a transform, which would otherwise trap a fixed child).
  // Inject the bottom-bar styles from the asset itself, so the feature does not
  // depend on base.css being freshly cached/parsed (which was failing live).
  function ensureBottomBarStyles() {
    if (document.getElementById('sbah-bottombar-css')) return;
    var css =
      '.sbah-bottombar{position:fixed;left:1rem;right:1rem;bottom:1rem;z-index:99990;' +
      'display:flex;align-items:center;justify-content:center;gap:.6rem;padding:.8rem 1.2rem;' +
      'border-radius:999px;background:radial-gradient(120% 300% at 50% 0%,#3a2630 0%,#1A1310 60%);' +
      'box-shadow:0 10px 30px rgba(26,19,16,.4);transform:translateY(160%);opacity:0;pointer-events:none;' +
      'transition:transform .4s cubic-bezier(.22,1,.36,1),opacity .3s ease;}' +
      '.sbah-bottombar.is-visible{transform:translateY(0);opacity:1;pointer-events:auto;}' +
      '@media(min-width:901px){.sbah-bottombar{display:none;}}' +
      ".sbah-bottombar .ldt-cr-course-nav-back{font-size:0;width:36px;height:36px;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;border:1.5px solid rgba(255,255,255,.28);background:transparent;color:#fff;padding:0;text-decoration:none;}" +
      '.sbah-bottombar .ldt-cr-course-nav-back svg{width:18px;height:18px;color:#fff;}' +
      ".sbah-bottombar .ldt-cr-member-logout{display:inline-flex;flex-direction:row;white-space:nowrap;align-items:center;gap:.4rem;font-family:var(--sb-display-sans),'Object Sans',sans-serif;font-weight:700;font-size:1.3rem;color:#fff;text-decoration:none;padding:.55rem 1.4rem;border:1.5px solid rgba(255,255,255,.28);border-radius:999px;}" +
      '.sbah-bottombar .ldt-cr-member-logout svg{width:14px;height:14px;}' +
      '.sbah-bottombar .ldt-cr-member-logout>*,.sbah-bottombar .sbah-lessons>*{display:flex;flex-direction:row;align-items:center;gap:.5rem;width:auto;}' +
      ".sbah-bottombar .sbah-lessons{display:inline-flex;flex-direction:row;white-space:nowrap;align-items:center;gap:.4rem;background:transparent;color:#fff;border:1.5px solid rgba(255,255,255,.28);border-radius:999px;padding:.55rem 1.4rem;font-family:var(--sb-display-sans),'Object Sans',sans-serif;font-weight:700;font-size:1.3rem;}" +
      '.sbah-bottombar .sbah-lessons svg{width:15px;height:15px;color:#fff;}' +
      '.sbah-bottombar .sbah__bell{display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;flex:0 0 auto;padding:0;border-radius:50%;border:1.5px solid rgba(255,255,255,.28);background:transparent;color:#fff;}' +
      '.sbah-bottombar .sbah__bell svg{width:18px;height:18px;color:#fff;}' +
      '.sbah-bottombar .sbah__bell>span{width:auto;gap:0;}' +
      '.sbah-bottombar .ldt-cr-course-nav-back{order:0;}.sbah-bottombar .sbah-lessons{order:1;}.sbah-bottombar .ldt-cr-member-logout{order:2;}.sbah-bottombar .sbah__bell{order:3;}' +
      '#ldt-app-proxy-root .sbah-bar .sbah-lessons>*,#ldt-app-proxy-root .sbah-bar .ldt-cr-member-logout>*{display:flex;flex-direction:row;align-items:center;gap:.5rem;width:auto;}' +
      '#ldt-app-proxy-root .sbah-bar .ldt-cr-member-logout,#ldt-app-proxy-root .sbah-bar .sbah__bell,#ldt-app-proxy-root .sbah__top .ldt-cr-member-logout,#ldt-app-proxy-root .sbah__top .sbah__bell{transition:border-color .18s ease,background .18s ease,color .18s ease;}' +
      '#ldt-app-proxy-root .sbah-bar .ldt-cr-member-logout:hover,#ldt-app-proxy-root .sbah-bar .sbah__bell:hover,#ldt-app-proxy-root .sbah__top .ldt-cr-member-logout:hover,#ldt-app-proxy-root .sbah__top .sbah__bell:hover{border-color:#FF8DBB;background:rgba(255,141,187,.16);}';
    var st = document.createElement('style');
    st.id = 'sbah-bottombar-css';
    st.textContent = css;
    document.head.appendChild(st);
  }

  function buildBottomBar(topBar) {
    ensureBottomBarStyles();
    var bb = document.querySelector('.sbah-bottombar');
    if (!bb) {
      bb = document.createElement('div');
      bb.className = 'sbah-bottombar';

      var back = topBar.querySelector('.sbah-bar__back .ldt-cr-course-nav-back') || topBar.querySelector('.sbah-bar__back a');
      var logout = topBar.querySelector('.ldt-cr-member-logout');
      var lessons = topBar.querySelector('.sbah-lessons');
      var bell = topBar.querySelector('.sbah__bell');

      if (back) bb.appendChild(back.cloneNode(true));
      if (logout) bb.appendChild(logout.cloneNode(true));
      if (lessons) {
        var lClone = lessons.cloneNode(true);
        lClone.addEventListener('click', function () {
          var n = document.querySelector('#ldt-app-proxy-root .ldt-cr-course-top-nav');
          var l = n && [].slice.call(n.querySelectorAll('button')).filter(function (x) { return /Lessons/i.test(x.textContent); })[0];
          if (l) l.click();
        });
        bb.appendChild(lClone);
      }
      if (bell) {
        var bClone = bell.cloneNode(true);
        bClone.addEventListener('click', function () {
          var n = document.querySelector('#ldt-app-proxy-root .ldt-cr-course-top-nav');
          var b = n && [].slice.call(n.querySelectorAll('button')).filter(function (x) { return x.querySelector('svg') && !x.textContent.trim(); })[0];
          if (b) b.click();
          positionNotif();
        });
        bb.appendChild(bClone);
      }
      document.body.appendChild(bb);
    }

    // Toggle by scroll direction (works no matter which element scrolls — this
    // app scrolls an inner container, not window, so a capture-phase listener
    // catches it). Uses the top bar's viewport position delta as the signal:
    // moving up while past the top → show; moving down (scrolling up) → hide.
    if (!window.__sbahScrollWired) {
      window.__sbahScrollWired = true;
      var lastBottom = null;
      document.addEventListener('scroll', function () {
        var bar = document.querySelector('.sbah-bottombar');
        var tb = document.querySelector('#ldt-app-proxy-root .sbah-bar');
        if (!bar || !tb) { if (bar) bar.classList.remove('is-visible'); return; }
        var cur = tb.getBoundingClientRect().bottom;
        if (lastBottom !== null) {
          if (cur < lastBottom - 2 && cur < 10) bar.classList.add('is-visible');
          else if (cur > lastBottom + 2) bar.classList.remove('is-visible');
        }
        lastBottom = cur;
      }, true);
    }
  }

  // Alleen schrijven als de waarde echt verandert: een gelijke textContent-set
  // vervangt toch de tekstnode en zou de MutationObserver eindeloos triggeren.
  function setText(el, value) {
    if (el && el.textContent !== String(value)) el.textContent = value;
  }

  /* De app rendert per tabblad één cursuslijst, elk met een eigen klasse:
       .ldt-cr-course-list-my-course  — waar de cursist is ingeschreven
       .ldt-cr-course-list-locked     — wat ze nog niet heeft
     Beide gebruiken dezelfde .ldt-cr-course-item, dus zonder deze scope telde
     de teller de vergrendelde kaarten mee: 12 cursussen bij nul inschrijvingen,
     en 21 zodra "laad meer" er negen bij rendert. */
  var MY_LIST = '#ldt-app-proxy-root .ldt-cr-course-list-my-course';

  /* Label en bestemming voor de knop als de cursist nog nergens is ingeschreven.
     Komen uit het script-tag in theme.liquid: het label uit de locales, de URL
     uit de theme-instellingen. De hero zelf staat in de app en kent geen Liquid. */
  var cfg = document.getElementById('nimbus-academy-hero');
  var EXPLORE_LABEL = cfg ? cfg.getAttribute('data-explore-label') : '';
  var EXPLORE_URL = cfg ? cfg.getAttribute('data-explore-url') : '';

  /* Het oorspronkelijke label onthouden: de app is een SPA, dus iemand kan zich
     inschrijven zonder paginaherlading en dan moet "Continue learning" terug. */
  var continueLabel = '';

  function setContinue(btn, href, label) {
    if (href && btn.getAttribute('href') !== href) btn.setAttribute('href', href);
    setText(btn, label);
  }

  function run() {
    rememberLesson();
    sanitizeHero();
    var topOk = buildTopBar();
    buildCourseBar();

    var elCourses = document.querySelector('.sbah-stat-courses');
    if (!elCourses) return topOk; // cursus- of lespagina (of hero afwezig)

    /* Staat de cursist op het tabblad Vergrendeld, dan is haar eigen lijst niet
       in de DOM. Dan niets schrijven: een eerder gezet aantal laten staan is
       beter dan het aantal vergrendelde cursussen tonen. */
    var list = document.querySelector(MY_LIST);
    if (!list) return topOk;

    var items = [].slice.call(list.querySelectorAll('.ldt-cr-course-item'));
    var done = items.filter(function (it) { return progress(it) >= 100; }).length;

    /* Nul is een geldige uitkomst en moet ook echt geschreven worden — de oude
       code stapte er bij een lege lijst uit en liet het vorige getal staan. */
    setText(elCourses, items.length);
    setText(document.querySelector('.sbah-stat-done'), done);
    setText(document.querySelector('.sbah-stat-cert'), done);

    var btn = document.querySelector('.sbah-continue');
    if (btn) {
      if (!continueLabel) continueLabel = (btn.textContent || '').trim();

      if (items.length) {
        var chosen =
          items.find(function (it) { var p = progress(it); return p > 0 && p < 100; }) ||
          items.find(function (it) { return progress(it) < 100; }) ||
          items[0];
        setContinue(btn, lastLesson() || (chosen ? viewHref(chosen) : null), continueLabel);
      } else if (EXPLORE_URL) {
        /* Nog nergens ingeschreven: doorverwijzen naar het cursusaanbod in
           plaats van naar een vergrendelde cursus die ze niet kan openen. */
        setContinue(btn, EXPLORE_URL, EXPLORE_LABEL || continueLabel);
      }
    }

    return topOk;
  }

  /* ── Bootstrap ────────────────────────────────────────────────────────
   * De app is een React-SPA: hij mount laat en rendert opnieuw bij navigatie
   * (cursus -> les). De oude aanpak stopte na 40 pogingen (12s) en gaf het
   * daarna definitief op — vandaar dat de opbouw soms pas na een refresh
   * verscheen. Nu: pollen tijdens het opstarten én een MutationObserver die
   * de hele paginalevensduur blijft luisteren. run() is idempotent.
   */
  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    var cb = function () {
      pending = false;
      try { run(); } catch (err) { /* app kan midden in een re-render zitten */ }
    };
    if (window.requestAnimationFrame) window.requestAnimationFrame(cb);
    else window.setTimeout(cb, 16);
  }

  /* Kijken op <body>, niet op #ldt-app-proxy-root. De app vervángt die root bij
     het wisselen van tabblad; een observer op de oude, losgekoppelde node gaat
     daarna nooit meer af. Omdat observeApp() alleen vanuit de opstartlus werd
     aangeroepen — en die stopt na een paar seconden — lag het bijwerken daarna
     stil, en bleven de cijfers hangen op de waarde van het vorige tabblad.
     <body> blijft bestaan. Alle mutaties worden door schedule() gebundeld tot
     één run() per frame, en run() schrijft alleen bij een echte verandering,
     dus dit lust zichzelf niet op. */
  var observed = false;
  function observeApp() {
    if (observed || !document.body) return;
    observed = true;
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    schedule();
  }

  var tries = 0;
  var boot = setInterval(function () {
    tries++;
    observeApp();
    schedule();
    if (observed && tries > 20) clearInterval(boot);   // observer is aan het roer
    if (tries > 200) clearInterval(boot);              // 60s harde stop
  }, 300);

  // SPA-navigatie en terugkeren naar het tabblad
  window.addEventListener('popstate', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) schedule();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observeApp(); schedule(); });
  } else {
    observeApp(); schedule();
  }
})();
